import { styled, css } from "styled-components";
import {
  Constrainer,
  HorizontalSpacer,
  VerticalSpacer,
} from "../../internal-components/Layout.js";
import { RichText } from "../../internal-components/RichText.js";

export interface Props {
  embed?: string;
  text?: string;
  stripStyle?: boolean;
}

export const Embed: React.FC<Props> = ({ embed, text, stripStyle }) => {
  if (!embed) {
    return null;
  }

  return (
    <VerticalSpacer>
      <HorizontalSpacer>
        <Constrainer>
          {text && <RichText dangerouslySetInnerHTML={{ __html: text }} />}
          <EmbedContent
            $stripStyle={stripStyle}
            dangerouslySetInnerHTML={{ __html: embed }}
          />
        </Constrainer>
      </HorizontalSpacer>
    </VerticalSpacer>
  );
};

const EmbedContent = styled.div<{ $stripStyle?: boolean }>`
  ${(props) =>
    !props.$stripStyle &&
    css`
      position: relative;
      overflow: hidden;
      padding-top: 56.25%;

      iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
      }
    `};
`;
